.page {
  padding: var(--page-pad-y) var(--page-pad-x) clamp(80px, 9vw, 140px);
  max-width: 1280px;
  margin: 0 auto;
  background: #fff;
  container-type: inline-size;
  container-name: orderSheet;
}

.head { margin-bottom: 16px; }

.crumb { margin-bottom: 8px; }

.back {
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
}

.title {
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  margin: 0 0 8px;
  letter-spacing: 0.04em;
}

.lede {
  margin: 0 0 16px;
  color: var(--color-ink-soft);
  font-size: 0.95rem;
  max-width: 60ch;
}

.searchRow { margin-bottom: 12px; }

.search {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.18);
  background: #fff;
  padding: 10px 14px;
  font: inherit;
  font-size: 0.95rem;
  border-radius: 6px;
  outline: none;
}

.search:focus { border-color: var(--color-ember); box-shadow: 0 0 0 3px rgba(243,154,46,0.18); }

.quickFilters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 4px 0 12px;
}

.usaToggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #fff;
  border: 1.5px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-ink);
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease, color 120ms ease;
}

.usaToggle:hover { border-color: var(--color-ink); }

.usaToggleActive {
  background: var(--color-ink);
  color: #fff;
  border-color: var(--color-ink);
}

.usaFlag { font-size: 1.1em; line-height: 1; }
.usaLabel { font-weight: 700; }

.usaState {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.08);
  color: inherit;
}

.usaToggleActive .usaState {
  background: var(--color-ember);
  color: #111;
}

.toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0 14px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--color-ink);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  cursor: pointer;
  user-select: none;
}

.toggle input { width: 18px; height: 18px; accent-color: var(--color-ember); }
.toggle + .toggle { border-top: 0; padding-top: 6px; margin-top: -6px; }
.toggleFlag { margin-right: 6px; font-size: 1.05em; }

.grid { display: flex; flex-direction: column; }

.legend {
  display: grid;
  grid-template-columns: minmax(200px, 260px) minmax(120px, 150px) 1fr 1fr;
  column-gap: 14px;
  padding: 8px 0;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
  border-top: 2px solid var(--color-ink);
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.legendItem { padding-left: 4px; }
.legendTotal { padding-left: 12px; text-align: right; }
.legendCol { padding-left: 12px; }

@container orderSheet (max-width: 760px) {
  .legend { display: none; }
}

/* Sticky draft summary at the bottom */
.draftBar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: #1f1b18;
  color: #f5f2ee;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -8px 30px rgba(0,0,0,0.18);
}

.draftSummary {
  display: flex;
  gap: 24px;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.draftRight { text-align: right; }

.draftLabel {
  font-size: 0.65rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(245, 242, 238, 0.6);
}

.draftQty, .draftTotal {
  font-size: 1.1rem;
  font-weight: 700;
}

.draftActions { display: flex; gap: 10px; align-items: center; }

.draftClear {
  background: transparent;
  border: 1px solid rgba(245, 242, 238, 0.35);
  color: #f5f2ee;
  padding: 10px 14px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.draftReview {
  background: var(--color-ember);
  border: 0;
  color: #111;
  padding: 12px 18px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.draftReview:disabled { opacity: 0.5; cursor: not-allowed; }

@media (max-width: 540px) {
  .draftBar { flex-direction: column; align-items: stretch; gap: 10px; padding: 10px 14px calc(12px + env(safe-area-inset-bottom)); }
  .draftSummary { justify-content: space-between; }
  .draftActions { justify-content: flex-end; }
  .draftReview { flex: 1; }
}
